module.exports = __webpack_public_path__ + "583788c6c768e593db90fcc583a1ca91.svg";